import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { Suspense } from 'react';

import { useUserStore } from '@store/app.store';
import { useMeetingPageState } from '@util/hooks';
import { lazyWithRetry } from '@util/helpers';
import ReskinMobileStickyNav from '@components/general/reskin-mobile-sticky-nav.component';
import MeetingDetailComponent from '@components/meeting/meeting-detail.component';
import MeetingAttendeesSection from '@components/meeting/meeting-attendees.component';
import MeetingOrganizations from '@components/meeting/meeting-organizations.component';

const Chat = lazyWithRetry(() => import('@components/meeting/meeting-chat.component'));

export default function MobileMeetingPage({ sections }) {
  const user = useUserStore((state) => state?.user);
  const isGuest = user?.isGuest;
  const { meetingId } = useParams();

  const { attendees, organizations, meeting, isLoading } = useMeetingPageState(meetingId);

  return (
    <Flex flexDir='column'>
      <Tabs variant='navDark'>
        <ReskinMobileStickyNav showCalendar={false}>
          <TabList w='full'>
            <Tab>Meeting Summary</Tab>
            {!isGuest && <Tab>People</Tab>}
            {!isGuest && <Tab>Organizations</Tab>}
          </TabList>
        </ReskinMobileStickyNav>
        <TabPanels
          p={3}
          pb={0}
        >
          <TabPanel
            maxW='720px'
            m='0 auto'
          >
            <MeetingDetailComponent sections={sections} />
          </TabPanel>
          {!isGuest && (
            <TabPanel p={1}>
              <MeetingAttendeesSection attendees={attendees} />
            </TabPanel>
          )}
          {!isGuest && (
            <TabPanel p={1}>
              <MeetingOrganizations
                organizations={organizations}
                meetingId={meetingId}
              />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
      <Suspense fallback={null}>{!isGuest && !isLoading && <Chat meeting={meeting} />}</Suspense>
    </Flex>
  );
}
